import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';

import { Col, Row } from 'react-bootstrap';

import { actions } from '../redux/ProductReducer';
import { Icon, Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import ProductTemplateBox from '../components/ProductTemplateBox/ProductTemplateBox';
import BrandListItem from '../components/BrandListItem/BrandListItem';
import getIncludedResource from '../../../helpers/getIncludedResource';

const EXCLUDED_INSURERS = ['LIM', 'IPP', 'CPP', 'AIGPA'];

const BrandListContainer = ({ params, getProduct, getInsurerList }) => {
  const { productId } = params;
  const { product, insurerList } = useSelector((state) => state.productManagement);
  const currentProductId = product?.data?.id;
  useEffect(
    () => {
      if (!currentProductId || currentProductId !== productId) {
        getProduct(productId);
      }
      getInsurerList(['schemes', 'organisation']);
    },
    [productId, currentProductId, getProduct, getInsurerList],
  );

  const refreshInsurerPage = () => {
    getInsurerList(['schemes', 'organisation']);
  };

  if (!product || !insurerList.data?.length || currentProductId !== productId) {
    return (
      <div className="admin-area product-container">
        <InternalContainer title={'Scheme Management'}>
          <Loader />
        </InternalContainer>
      </div>
    );
  }

  const validInsurers = insurerList.data?.filter((insurer) => {
    return !EXCLUDED_INSURERS.includes(insurer.id);
  });

  return (
    <div className="admin-area product-container">
      <InternalContainer title={'Scheme Management'}>
        <ProductTemplateBox
          title={'(Select Brand)'}
          productIcon={<Icon name="plane" />}
          productName={product?.data?.attributes?.name}
        >
          <Row>
            {validInsurers?.map((insurer, key) => {
              const organisation = getIncludedResource(
                insurer,
                insurerList.included,
                'organisation',
              );
              const insurerSchemes = getIncludedResource(
                insurer,
                insurerList.included,
                'schemes',
              );
              return (
                <Col sm={3}>
                  <div className="animated fadeIn" key={key}>
                    <BrandListItem
                      productId={productId}
                      insurer={insurer}
                      insurerSchemes={insurerSchemes}
                      organisationName={organisation?.data?.attributes?.name}
                      onRefreshInsurerPage={refreshInsurerPage}
                    />
                  </div>
                </Col>
              );
            })}
          </Row>
        </ProductTemplateBox>
      </InternalContainer>
    </div>
  );
};

export default connect(
  null,
  {
    getProduct: actions.getProduct,
    getInsurerList: actions.getInsurerList,
  },
)(BrandListContainer);
